<template>
  <div class="button_component_wrapper">
    <input
      type="checkbox"
      v-model="data.pressed"
      @change="ChangeValue(data)"
      class="input_button_component"
      :id="data.id"
      :value="data.pressed"
    />
    <label
      class="label_button_component blue_bg"
      :class="{ hasChecker: hasChecker }"
      :for="data.id"
    >
      {{ data.title }}</label
    >
  </div>
</template>

<script>
export default {
  name: 'CheckBtn',
  props: {
    hasChecker: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Object,
      default: {},
    },
  },
  methods: {
    ChangeValue(data) {
      this.$emit('change', data)
    },
  },
}
</script>
